module.exports = __webpack_public_path__ + "static/media/carousel-img04.a9fb1ee9.png";